// src/utils/formatters.js

// Teléfono Puerto Rico (787) 555-1234
export const formatPhone = (value) => {
  if (!value) return '';
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

// Moneda USD $1,234.56
export const formatCurrency = (amount, symbol = '$') => {
  return `${symbol}${parseFloat(amount || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

// Fecha en español
export const formatDate = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('es-PR', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
  });
};

// Edad de mascota desde fecha de nacimiento
export const calcularEdadMascota = (fechaNacimiento) => {
  if (!fechaNacimiento) return 'Desconocida';
  const hoy = new Date();
  const nacimiento = new Date(fechaNacimiento);
  let años = hoy.getFullYear() - nacimiento.getFullYear();
  let meses = hoy.getMonth() - nacimiento.getMonth();
  if (meses < 0 || (meses === 0 && hoy.getDate() < nacimiento.getDate())) {
    años--;
    meses += 12;
  }
  if (años === 0) return `${meses} meses`;
  return `${años} año${años !== 1 ? 's' : ''}${meses > 0 ? `, ${meses} meses` : ''}`;
};
